module.exports = "<span ng-bind=ctrl.value></span>";